module.exports = __webpack_public_path__ + "img/hr-brown-fluff-dry-03.2fe1df38.png";